import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/styles";
import { AutoRotatingCarousel } from 'material-auto-rotating-carousel';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
// import image01 from './bds_images/image01.jpg';
import image09 from './bds_images/image09.jpg';
import image02 from './bds_images/image02.jpg';
import image04 from './bds_images/image04.jpg';
import image03 from './bds_images/image03.jpg';
import image06 from './bds_images/image06.jpg';
import image10 from './bds_images/image10.jpg';
// import image05 from './bds_images/image05.jpg';

import {
    Card,
    Icon,
    IconButton,
    Grid,
    Dialog,
    DialogTitle,
    DialogContentText,
    DialogContent,
    DialogActions,

    Divider,
    Radio,
    RadioGroup,
    FormControlLabel,
    Checkbox,
    TextField,
    Tooltip,
    Fab,
    Switch,
    Typography,
    Box,
    useTheme,
} from '@material-ui/core'
import { Autocomplete, createFilterOptions } from '@material-ui/lab';



import { LoonsTable, DatePicker, FilePicker, Button, ExcelToTable, LoonsSnackbar, LoonsDialogBox, LoonsSwitch, MainContainer, LoonsCard, CardTitle } from "app/components/LoonsLabComponents";

const Slide = require('./Slide').default;

const styleSheet = ((theme) => ({

}));


const images = [
    {
        label: 'tiger',
        imgPath: 'assets/images/bds_images/image09.jpg'
    },
    {
        label: 'dolfin',
        imgPath: 'assets/images/bds_images/image02.jpg'
    },
    {
        label: 'sunset',
        imgPath: 'assets/images/bds_images/image04.jpg'
    },
    {
        label: 'doly',
        imgPath: 'assets/images/bds_images/image03.jpg'
    },
    {
        label: 'ducks',
        imgPath: 'assets/images/bds_images/image05.jpg'
    },
    {
        label: 'tiger',
        imgPath: 'assets/images/bds_images/image06.jpg'
    },
    {
        label: 'river',
        imgPath: 'assets/images/bds_images/image10.jpg'
        
    },
    {
        label: 'sunset',
        imgPath: 'assets/images/bds_images/image03.jpg'
    }
];


class HomePage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeStep : 0 ,
            open: true,
        }
    }




    componentDidMount() {

    }

    render() {
        const { classes } = this.props



        return (
            <Fragment>
                <div style={{ position: 'relative', width: '100%', height: 700 }}>
                    {/* <Button onClick={() => this.setState({ open: true })}>Open carousel</Button> */}
                    <AutoRotatingCarousel
                        label='Get Started'
                        open={this.state.open}
                        onClose={() => this.setState({ open: false })}
                        onStart={() => this.setState({ open: false })}
                        mobile
                        autoplay={true}
                        style ={{position:'absolute'}}
                    >
                        <Slide                                    
                            media={<img src={image09} />}
                            // mediaBackgroundStyle={{ backgroundColor: red[400] }}
                            // style={{ backgroundColor: red[600] }}
                            title='1 This is a very cool feature'
                            subtitle='Just using this will blow your mind.'
                        />
                        <Slide
                            media={<img src={image02} />}
                            // mediaBackgroundStyle={{ backgroundColor: blue[400] }}
                            // style={{ backgroundColor: blue[600] }}
                            title='2 Ever wanted to be popular?'
                            subtitle='Well just mix two colors and your are good to go!'
                        />
                        <Slide
                            media={<img src={image04} />}
                            // mediaBackgroundStyle={{ backgroundColor: blue[400] }}
                            // style={{ backgroundColor: blue[600] }}
                            title='2 Ever wanted to be popular?'
                            subtitle='Well just mix two colors and your are good to go!'
                        />
                        <Slide
                            media={<img src={image03} />}
                            // mediaBackgroundStyle={{ backgroundColor: blue[400] }}
                            // style={{ backgroundColor: blue[600] }}
                            title='2 Ever wanted to be popular?'
                            subtitle='Well just mix two colors and your are good to go!'
                        />
                        <Slide
                            media={<img src={image06} />}
                            // mediaBackgroundStyle={{ backgroundColor: blue[400] }}
                            // style={{ backgroundColor: blue[600] }}
                            title='2 Ever wanted to be popular?'
                            subtitle='Well just mix two colors and your are good to go!'
                        />
                        <Slide
                            media={<img src={image10} />}
                            // mediaBackgroundStyle={{ backgroundColor: blue[400] }}
                            // style={{ backgroundColor: blue[600] }}
                            title='2 Ever wanted to be popular?'
                            subtitle='Well just mix two colors and your are good to go!'
                        />
                    </AutoRotatingCarousel>
               </div>
            </Fragment>
        )
    }
}
export default withStyles(styleSheet)(HomePage);